let levelIdByKey: Record<string, number> = {};

export const setCustomSkillLevelIdMap = (map: Record<string, number>) => {
  levelIdByKey = { ...map };
};

export const getCustomSkillLevelId = (key: string): number | undefined => {
  return levelIdByKey[key];
};
